import { centerAligned } from '@medly-components/utils';
import styled from 'styled-components';

export const FooterLogoWrapper = styled('div')`
    ${centerAligned('flex')}
    gap: 1.2rem;
    flex-direction: column-reverse;

    & > * {
        flex: 1;
    }

    & > div {
        justify-content: center;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        flex: 2;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Footer = styled('footer')`
    min-height: 8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    gap: 2.8rem;
    border-top: 0.2rem solid ${({ theme }) => theme.colors.grey[300]};
    padding: 2.4rem;

    & > *:last-child {
        flex: 1;
        text-align: end;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        gap: 0;
        flex-direction: row;
        padding: 0 2.4rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.L.min}px) {
        padding: 0 9.6rem;
    }
`;
